import React, {useEffect, useState} from 'react';
import {companyService, driverService} from '../../../services';
import {Modal, notification, Button, Table, Col, Row} from 'antd';
import {fileHelper} from "../../../helpers/file.helper";
import ModalChangeUserLogin from '../change-user-login';
import i18n from '../../../i18n';

export default function ModalDriverInfo({driverId, truckId, trailId, isShow, setIsShow}) {
  const driverInfoAliases = {
    fio: i18n.t('constants.driverInfoAliases.fio'),
    phone: i18n.t('constants.driverInfoAliases.phone'),
    passportSerial: i18n.t('constants.driverInfoAliases.passportSerial'),
    passportNumber: i18n.t('constants.driverInfoAliases.passportNumber'),
    passportDate: i18n.t('constants.driverInfoAliases.passportDate'),
    scanPassportHomePage: i18n.t('constants.driverInfoAliases.scanPassportHomePage'),
    scanPassportRegPage: i18n.t('constants.driverInfoAliases.scanPassportRegPage'),
    License: i18n.t('constants.driverInfoAliases.license'),
    scanDriverLicense1: i18n.t('constants.driverInfoAliases.scanDriverLicense1'),
    scanDriverLicense2: i18n.t('constants.driverInfoAliases.scanDriverLicense2'),
    regCountry: i18n.t('constants.driverInfoAliases.regCountry'),
  };

  const truckInfoAliases = {
    name: i18n.t('constants.truckInfoAliases.name'),
    carrying: i18n.t('constants.truckInfoAliases.carrying'),
    capacity: i18n.t('constants.truckInfoAliases.capacity'),
    regCountry: i18n.t('constants.truckInfoAliases.regCountry'),
    scanSts1: i18n.t('constants.truckInfoAliases.scanSts1'),
    scanSts2: i18n.t('constants.truckInfoAliases.scanSts2'),
  };

  const trailInfoAliases = {
    name: i18n.t('constants.trailInfoAliases.name'),
    carrying: i18n.t('constants.trailInfoAliases.carrying'),
    capacity: i18n.t('constants.trailInfoAliases.capacity'),
    scanSts1: i18n.t('constants.trailInfoAliases.scanSts1'),
    scanSts2: i18n.t('constants.trailInfoAliases.scanSts2'),
  };

  const [tableData, setTableData] = useState([]);
  const [table1Data, setTable1Data] = useState([]);
  const [truckTableData, setTruckTableData] = useState([]);
  const [trailTableData, setTrailTableData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [truckDataLoaded, setDataTruckLoaded] = useState(false);
  const [trailDataLoaded, setDataTrailLoaded] = useState(false);
  const [showUserChangeLoginModal, setShowUserChangeLoginModal] = useState(null);
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);

  const [columns, setColumns] = useState([
    {
      title: '',
      key: 'name',
      render: record => {
        if (record.isBoldText) {
          return (<b>{record.name}</b>);
        }
        return record.name;
      }
    },
    {
      title: '',
      key: 'data',
      render: record => {
        function isUrl(string) {
          let regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
          return regexp.test(string);
        }

        if (isUrl(record.data)) {
          return (
            <React.Fragment>
              <a href={record.data} target="_blank" rel="noopener noreferrer" className="active">
                <img alt={record.data} src={record.data} style={{width: "300px"}}/>
              </a>
            </React.Fragment>
          );
        } else if (record.name === "Моб. номер") {
          return (
            <React.Fragment>
              <a href={`tel:+7${record.data}`}
                 className="active">{record.data.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/g, `+7 ($1) $2 $3 $4`)}</a>
            </React.Fragment>
          )
        } else {
          if (record.data === 0 || record.data === 1) {
            return record.data ? i18n.t('main.yes') : i18n.t('main.no');
          }
          return record.data
        }
      }
    },
  ]);

  useEffect(() => {
    if (isShow) {
      if (!dataLoaded || isNeedUpdate) {
        companyService.getCompanyDriversQuestionnaire(driverId)
          .then((response) => {
            setTableData(response);

            setDataLoaded(true);
          })
          .catch((err) => {
            notification.error({
              message: i18n.t('components.notification.titles.getCompanyDriversQuestionnaire'),
              description: err,
            });
            setDataLoaded(false);
          })
      }

      if (truckId !== null && !truckDataLoaded) {
        companyService.getCompanyTrucksQuestionnaire(truckId)
          .then((response) => {
            setTruckTableData(response);

            setDataTruckLoaded(true);
          })
          .catch((err) => {
            notification.error({
              message: i18n.t('components.notification.titles.getCompanyTrucksQuestionnaire'),
              description: err,
            });
            setDataTruckLoaded(false);
          })
      }

      if (trailId !== null && !trailDataLoaded) {
        companyService.getCompanyTrailsQuestionnaire(trailId)
          .then((response) => {
            setTrailTableData(response);

            setDataTrailLoaded(true);
          })
          .catch((err) => {
            notification.error({
              message: i18n.t('components.notification.titles.getCompanyTrailsQuestionnaire'),
              description: err,
            });
            setDataTrailLoaded(false);
          })
      }
    }
  }, [dataLoaded, trailDataLoaded, truckDataLoaded, isShow, isNeedUpdate]);

  useEffect(() => {
    if (isShow && tableData) {
      let data = [];

      Object.keys(tableData).forEach((element) => {
        if (tableData[element] !== null && tableData[element] !== '') {
          if (typeof driverInfoAliases[element] !== 'undefined')
            data.push(
              {
                name: driverInfoAliases[element],
                data: tableData[element],
                isBoldText: element === 'fio'
              }
            );
        }
      });

      Object.keys(truckTableData).forEach((element) => {
        if (truckTableData[element] !== null && truckTableData[element] !== '') {
          if (typeof truckInfoAliases[element] !== 'undefined')
            data.push(
              {
                name: truckInfoAliases[element],
                data: truckTableData[element],
                isBoldText: element === 'name'
              }
            );
        }
      });

      if (trailTableData) {
        Object.keys(trailTableData).forEach((element) => {
          if (trailTableData[element] !== null && trailTableData[element] !== '') {
            if (typeof trailInfoAliases[element] !== 'undefined')
              data.push(
                {
                  name: trailInfoAliases[element],
                  data: trailTableData[element],
                  isBoldText: element === 'name'
                }
              );
          }
        });
      }

      if (tableData['userId'] && tableData['userName']) {
        let userInfo = [];
        userInfo.push((<>
            <span>{tableData['userName']}</span>
          </>
        ));

        data.push(
          {
            name: i18n.t('modals.modalDriverInfo.fields.userName.title'),
            data: userInfo,
            isBoldText: true,
          }
        );
      }

      setTable1Data(data);
    }
  }, [isShow, tableData]);

  const handleDownloadDocsArchive = (driverId) => {
    driverService.getDocsArchive({id: driverId})
      .then(resp => {
        fileHelper.downloadFileBase64(resp, `${i18n.t('modals.modalDriverInfo.fileName', {name:tableData ? tableData.fio : driverId})}.zip`);
      })
      .catch(err => {
        notification.error({
          message: i18n.t('components.notification.titles.getDocsArchive'),
          description: err
        });
      });
  };

  return (
    <Modal
      title={i18n.t('modals.modalDriverInfo.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={<Row gutter={[10, 10]}>
        <Col offset={8} span={8}>
          <Button
            htmlType="button"
            key="submitPrev"
            onClick={() => handleDownloadDocsArchive(driverId)}
            type="primary"
            size="large"
            style={{width: '100%'}}
          >
            {i18n.t('modals.modalDriverInfo.buttons.download')}
          </Button>
        </Col>
        {tableData['userId'] && <Col offset={8} span={8}>
          <Button
            htmlType="button"
            type="primary"
            key="changeLogin"
            size="large"
            style={{width: '100%'}}
            onClick={() => {
              setShowUserChangeLoginModal(tableData['userId']);
            }}>
            {i18n.t('modals.modalDriverInfo.buttons.changeLogin')}
          </Button>
          <ModalChangeUserLogin
            id={tableData['userId']}
            isShow={showUserChangeLoginModal === tableData['userId']}
            setIsShow={() => {
              setShowUserChangeLoginModal(null)
            }}
            setNeedUpdateList={setIsNeedUpdate}
          />
        </Col>}
      </Row>}
    >
      <Table
        showHeader={false}
        columns={columns}
        dataSource={table1Data}
        rowKey="name"
        pagination={false}
        size="small"
      />
    </Modal>
  );

}
